export const isMobile: boolean = window.screen.width <= 480;
